<template id="post">
  <article class="post" :class="{ active: getActive === place }" :data_id="place.id">
    <div
      @click="openPost()"
      class="post-container"
      :style="{ backgroundImage: 'url(' + place.cover + ')' }"
      :class="{ cover: place.cover }"
    >
      <p class="post-title">{{ place.title | cutString(76) }}</p>
      <div class="categoryy" v-if="place.sports">
        <div
          v-for="cat in place.sports"
          :key="cat.id"
          class="categoryy-item"
          :class="cat.color"
          @click.stop.prevent="setFilter(cat)"
        >
          {{ cat.ru }}
        </div>
      </div>
      <div class="post-info">
        <div class="post-info-wrap">
          <p class="post-info__adress">{{ place.country || place.state ? place.country + ', ' + place.state : 'Без места' }}</p>
        </div>
        <div class="post-info-wrap">
          <!-- <div
            class="post-info__user"
            @click="openAuthor()"
            :style="{ backgroundImage: 'url(' + event.author.avatar + ')' }"
          > -->
          <!-- <span v-if="event.users">+{{ event.users.length }}</span> -->
          <!-- </div> -->
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import { commonFilters } from '@/mixins.js';

export default {
  props: {
    place: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    active: false,
  }),
  mixins: [commonFilters],
  computed: {
    getActive() {
      return this.$store.getters.getActivePlace;
    },
    getModePlaces() {
      return this.$store.getters.getModePlaces;
    },
  },
  methods: {
    setFilter(cat) {
      cat.active = true;
      this.$store.dispatch('changeSports', cat);
    },
    async openPost() {
      let hash = this.$route.params.hash;
      if (hash) {
          if (hash.split('&')[0] == this.place.id) {
            this.$store.dispatch('changeModePlaces', false);
          } else {
            this.$router.push({ name: 'place', params: { hash: this.place.id + '&' + this.place.hash } });
          }
      } else {
        this.$router.push({ name: 'place', params: { hash: this.place.id + '&' + this.place.hash } });
      }
    },
    openAuthor() {
      let link = this.$router.resolve({
        name: 'profile',
        params: { id: this.place.author.id },
      });
      window.open(link.href, '_blank');
    }
  },
  mounted() {
    this.active = this.getActive === this.place ? true : false;
  },
};
</script>

<style lang="stylus">
.post
  width 100%
  max-width 600px
  min-width 300px
  min-height 185px
  position relative
  cursor pointer
  margin-top 20px
  // box-shadow 0px 0px 15px rgba(162, 162, 162, 0.3)
  // border-radius 20px
  // animation fadeInUp 0.4s alternate
  // animation-delay 0
  +to-width(1023px)
    margin 10px
    width calc(33.333% - 20px)
    min-width 275px
  +to-width(1000px)
    margin 10px
    width calc(50% - 20px)
    min-width 275px
  +to-width(720px)
    margin 5px 0
    width calc(100% - 20px)
    max-width 360px
    min-width 275px
    margin-left auto
    margin-right auto
  +to-width(460px)
    max-width initial
    width 100%
  // &:after
  //   content ''
  //   position absolute
  //   bottom 0px
  //   left 15px
  //   right 15px
  //   height 30px
  //   border-radius 20px
  //   background-color #fbf2db
  //   background-color #20859b
  //   z-index 2
  //   t()
  // &:before
  //   content ''
  //   position absolute
  //   bottom 0px
  //   left 30px
  //   right 30px
  //   height 30px
  //   border-radius 20px
  //   background-color #f6eed7
  //   background-color #2e5364
  //   z-index 1
  //   t()
  &:first-child
    margin-top 0
    +to-width(1023px)
      margin-top 10px

  &:hover
    &:after
      bottom -8px

  &:active
    &:before
      bottom -15px

  &.hovered
    &:after
      bottom -8px
      
  &.active
    &:after
      bottom -8px
    &:before
      bottom -15px

  &-help
    position absolute
    right -100%

  &-title
    font-size 18px
    font-weight 600
    letter-spacing 0.2px
    line-height 26px
    color var(--main)
    position relative
    z-index 2
    +to-width(1400px)
      font-size 18px
      line-height 28px
    
    &_small
      font-size 14px
  
  &-container
    position absolute
    padding 15px 30px
    display flex
    align-items center
    left 0
    right 0
    top 0
    bottom 0
    z-index 3
    background-color #fff7e1
    border-radius 30px
    background-size cover
    background-position top center
    content-visibility auto
    overflow hidden
    +to-width(1400px)
      padding 15px 20px

    .post-info
      z-index 2
    .category
      z-index 3
    
    &.cover
      .post-title
        color white
      .post-info__adress
        opacity 1
        color white
      .post-info__place
        color white
        opacity 0.6
      .post-info__tag:after
        background white
      .post-info__place:after
        background white
      .post-info__user
        span
          border 1px solid white
      &:after
        content ''
        left 0
        right 0
        top 0
        bottom 0
        position absolute
        background-color rgba(0,0,0,0.4)
    
      

@keyframes fadeInUp{
  0% {
    opacity 0
    transform translateY(20px)
  }
  100%{
    opacity 1
    transform translateY(0px)
  }
}
</style>